import { getTierByCi } from '../lib/press'

// ── RankBadge ─────────────────────────────────────────────────
// Shows [INDICATOR] next to a writer's name
// Usage: <RankBadge columnInches={120} isVoice={false} size="sm" />

export default function RankBadge({ columnInches = 0, isVoice = false, size = 'sm' }) {
  const tier = getTierByCi(columnInches, isVoice)
  if (tier.rank === 1) return null // Cubs get no badge — earn it first

  const sizes = {
    sm: { fontSize: '0.52rem', padding: '1px 5px', gap: '0.3rem' },
    md: { fontSize: '0.6rem',  padding: '2px 7px', gap: '0.4rem' },
    lg: { fontSize: '0.7rem',  padding: '3px 9px', gap: '0.5rem' },
  }
  const s = sizes[size] || sizes.sm

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: s.gap,
      fontFamily: "'Courier New', monospace",
      fontSize: s.fontSize,
      letterSpacing: '0.1em',
      color: tier.color,
      border: `1px solid ${tier.color}`,
      padding: s.padding,
      lineHeight: 1,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      opacity: 0.9,
    }}>
      <span style={{ fontSize: `calc(${s.fontSize} * 1.3)` }}>{tier.badge}</span>
      {tier.indicator}
    </span>
  )
}
